export { AccordionItem, type AccordionItemProps } from './accordion';
